import { Box, Typography } from "@mui/material";
import React from "react";
import Loader from "../assets/logo/loader.svg";
import * as Proptypes from "prop-types";
import AppButton from "./AppButton";
export default function AppLoader({
  sx,
  title,
  closeWindowButton,
  fontSize = 14,
  textAlign = "left",
  loader = true
}) {
  return (
    <Box sx={{ ...sx }}>
      {loader && <Loader className="loader" />}
      {!!title && (
        <Typography
          variant="subtitle2"
          color="#F8FAFF"
          sx={{ marginTop: 1 }}
          textTransform="capitalize"
          marginLeft={2}
          fontSize={fontSize}
          textAlign={textAlign}
        >
          {title}
        </Typography>
      )}
      {!!closeWindowButton && (
        <AppButton
          onClick={() => {
            // eslint-disable-next-line no-restricted-globals
            window.opener = self;
            window.close();
          }}
          sx={{ width: "200px" }}
          title="Close"
        />
      )}
    </Box>
  );
}

AppLoader.propTypes = {
  sx: Proptypes.any,
  title: Proptypes.string,
  closeWindowButton: Proptypes.bool,
};
